import React from "react";


const NonEditInput = ({value})=>{
    return(
        <>{value}</>
    )
}

export default NonEditInput;